import { stubFalse } from 'lodash-es';
import { useContext, useMemo } from 'react';

import { View } from '../../app/enums/ViewMapMode';
import { FATypes } from '../../components/adapters/fontAwesomeAdapters';
import { MonitorContext } from './monitorContexts';

export const VIEWS = [
  {
    name: View.MAP,
    icon: 'map',
    type: FATypes.REGULAR,
    isDisabled: data =>
      Object.values(data).some(({ rows }) =>
        rows.some(sh => sh.metadata?.blindingInformation?.location)
      ),
    disabledTooltipId: 'gdpr.blinded',
  },
  {
    name: View.LIST,
    icon: 'list-ul',
  },
];

export function useMonitorViews() {
  const { data } = useContext(MonitorContext);

  const views = useMemo(
    () =>
      VIEWS.map(({ isDisabled = stubFalse, ...rest }) => ({
        disabled: isDisabled(data),
        ...rest,
      })),
    [data]
  );

  return views;
}
